import React from "react";

import cn from "classnames";

import styles from "./LoadingDots.module.scss";

interface Props {
  mini?: boolean;
}

const LoadingDots = ({ mini }: Props) => {
  return <div className={cn(styles.loader, { [styles.miniLoader]: !!mini })} />;
};

export default LoadingDots;
